module.exports = __webpack_public_path__ + "img/orange_013.5dabf0fe.png";